import { atomFamily } from "jotai/utils";

import { createDerivedSessionAtom } from "../../../atoms/utils/createDerivedSessionAtom";
import { createPersistedAtom } from "../../../atoms/utils/createPersistedAtom";

const sessionLastVisitedPageAtom = atomFamily((sessionId: string) =>
  createPersistedAtom<string | null>(`lastVisitedPage-${sessionId}`, null)
);
export const lastVisitedPageAtom = createDerivedSessionAtom<string | null>(sessionLastVisitedPageAtom);
